import React from 'react';
import { css } from '@emotion/react';
import { PolymorphicComponentPropWithRef } from '../../../type-utils';

type ComponentProps = {
  children: React.ReactNode;
  className?: string;
};

type TrayBodyProps<T extends React.ElementType> = PolymorphicComponentPropWithRef<T, ComponentProps>;

export const TrayBody = React.forwardRef(
  <T extends React.ElementType = 'section'>(
    { as, children, ...rest }: TrayBodyProps<T>,
    ref: React.Ref<HTMLElement>
  ) => {
    const Component = as || 'section';
    return (
      <Component
        ref={ref}
        className='tray-body'
        css={css`
          flex: 1;
          overflow-y: auto;
        `}
        {...rest}
      >
        {children}
      </Component>
    );
  }
);

TrayBody.displayName = 'TrayBody';
